module.exports = __webpack_public_path__ + "static/sui-table-selected-14a3378c7309922d9814f534fa6e9423.png";